<div class="box" [class.success]="isSuccess" [class.warning]="isWarning" [class.danger]="isDanger" [class.info]="isInfo" [class.message]="isMessage" 
[class.success-info]="isSuccessInfo" [class.danger-info]="isDangerInfo">
  <ng-content></ng-content>
</div>
